// 静态菜单配置（偏前端UI的配置，服务端不存偏前端的UI的配置）
interface IDBIStaticMenuCfg {
  // 菜单className
  className: string;
}

// 静态菜单配置
export const STATIC_MENU_CFG_MAPPING: IRecord<IDBIStaticMenuCfg> = {
  // Following
  '1000': {
    className: 'dbi-user-guide__menu-following',
  },
  // TopCharts
  '2000': {
    className: 'dbi-user-guide__menu-topcharts',
  },
  // TopCharts/PCGames
  '2200': {
    className: 'dbi-user-guide__menu-pc-games',
  },
  // TopCharts/Companies
  '2500': {
    className: 'dbi-user-guide__menu-companies',
  },
  // StoreRanks
  '3000': {
    className: 'dbi-user-guide__menu-storeranks',
  },
  // MarketProfile
  '4000': {
    className: 'dbi-user-guide__menu-market-profile',
  },
  // GenreProfile
  '5000': {
    className: 'dbi-user-guide__menu-genre-profile',
  },
  // Reports/MarketReports
  '7200': {
    className: 'dbi-user-guide__menu-market-reports',
  },
  // Streaming
  '13000': {
    className: 'dbi-user-guide__menu-streaming',
  },
  // Sources&Metrics/Overview
  '16100': {
    className: 'dbi-user-guide__menu-sources-metrics-overview',
  },
  // Sources&Metrics/Sources
  '16200': {
    className: 'dbi-user-guide__menu-sources-metrics-sources',
  },
  // Sources&Metrics/Metrics
  '16300': {
    className: 'dbi-user-guide__menu-sources-metrics-metrics',
  },
};
